@if (display) {
  <p-dialog [styleClass]="authenticationService?.user?.fontSize === 'SMALL' ? 'custom-form-small' : (authenticationService?.user?.fontSize === 'MEDIUM' ? 'custom-form-medium' : '')" header="{{title}}" [(visible)]="display" showEffect="fade" [modal]="true" appendTo="body" [style]="{'width':'850px'}">
<div [ngClass]="{'custom-form-small': authenticationService?.user?.fontSize === 'SMALL', 'custom-form-medium': authenticationService?.user?.fontSize === 'MEDIUM'}">
    <div class="container-md">
      <div class="ui-grid-row">
        <div class="ui-grid-col-12">
          @for (msg of messages; track msg) { <p-message [severity]="msg.severity" [text]="msg.detail"></p-message> }
        </div>
      </div>
      <!-- #FORM BODY -->
      <div class="row mt-4">
        <div class="col-sm-6">
          <label for="code" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
          {{'control-panel.clients.codeBa' | translate}}
        </label>
          <input pInputText id="code" class="form-control custom-input" [(ngModel)]="entity.code" />
        </div>
        <div class="col-sm-6">
          <label for="name" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
          {{'general.name' | translate}}
        </label>
          <input pInputText id="name" class="form-control custom-input" [(ngModel)]="entity.name" />
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-sm-6">
          <label for="population" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
          {{'control-panel.clients.populationBa' | translate}}
        </label>
          <input pInputText id="population" class="form-control custom-input" [(ngModel)]="entity.population" />
        </div>
        <div class="col-sm-6">
          <label for="country" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
          {{'control-panel.clients.countryBa' | translate}}
        </label>
          <input pInputText id="country" class="form-control custom-input" [(ngModel)]="entity.country" />
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-sm-6">
          <label for="province" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
          {{'control-panel.clients.provinceBa' | translate}}
        </label>
          <input pInputText id="province" class="form-control custom-input" [(ngModel)]="entity.province" />
        </div>
        <div class="col-sm-6">
          <label for="postalCode" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
          {{'control-panel.clients.postalCodeBa' | translate}}
        </label>
          <input pInputText id="postalCode" class="form-control custom-input" [(ngModel)]="entity.postalCode" />
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-sm-6">
          <label for="address" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
          {{'control-panel.clients.addressBa' | translate}}
        </label>
          <input pInputText id="address" class="form-control custom-input" [(ngModel)]="entity.address" />
        </div>
        <div class="col-sm-6">
          <label for="cif" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
          {{'control-panel.clients.cif' | translate}}
        </label>
          <input pInputText id="cif" class="form-control custom-input" [(ngModel)]="entity.cif" />
        </div>
      </div>
      <!-- ACTIVE -->
      @if (!isNew) {
        <div>
          <div class="row mt-3">
            <div class="col-sm-6">
              <label for="active" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
            {{'general.active' | translate}}
          </label>
              <input id="active" class="form-check-input d-flex justify-content-center align-items-center custom-checkbox"
                type="checkbox" [(ngModel)]="entity.enabled" [disabled]="true" />
            </div>
          </div>
        </div>
      }
    </div>
  </div>
<ng-template pTemplate="footer">
      <div class="d-flex justify-content-center bd-highlight">
        <div class="p-2 bd-highlight">
          @if (!isNew) {
            <div>
              <button class="btn custom-button" (click)="save()" i18n>
            {{'general.save' | translate}}
          </button>
            </div>
          }
          @if (isNew) {
            <div>
              <button class="btn custom-button" (click)="save()" i18n>
            {{'general.create' | translate}}
          </button>
            </div>
          }
        </div>
        <div class="p-2 bd-highlight">
          @if (!isNew) {
            <div>
              <button class="btn custom-button" (click)="changeStatus(!entity.enabled)" i18n>
            {{'general.changeStatus' | translate}}
          </button>
            </div>
          }
        </div>
      </div>
    </ng-template>
</p-dialog>
}